
const mySwiper = new Swiper('.swiper-container', {
  // Optional parameters
  direction: 'horizontal',
  speed: 400,
  loop: true,
  autoplay: {
          delay: 10000
      },

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }
});

/*Evitar que los slides tipo video se queden pegados al arrastrar  */
document.querySelectorAll('.swiper-slide video').forEach(video => {
  // Evita el arrastre nativo del video
  video.setAttribute('draggable', 'false');
  
  video.addEventListener('pointerdown', (event) => {
    if (event.pointerType === 'mouse') {
      // Evita que se quede "pegado" solo en mouse  
      event.preventDefault(); 
    }
  });

  // Evita selección del video
  video.addEventListener('dragstart', (event) => event.preventDefault());
});